import { createAsyncThunk } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi } from "../../app/store";
import { AnaylseData, AuthListValue } from "../../models/Anaylse";
import * as S from "../../services/ProvinceDataAnalyse";

//省数据分析-监管数据占比
export const getProvinceDataAnaylseData = createAsyncThunk<
  AnaylseData[],
  number,
  AppThunkApi
>("Province/getAnaylseData", async (scope, api) => {
  return send(S.getProvinceDataAnaylse(scope), api);
});

// 省数据分析 - 监管数据变化
export const getProvinceDataContrastData = createAsyncThunk<
  AnaylseData[],
  number,
  AppThunkApi
>("Province/getContrastData", async (scope, api) => {
  return send(S.getProvinceDataContrast(scope), api);
});

export const getProvinceAuthList = createAsyncThunk<
  AuthListValue[],
  number | undefined,
  AppThunkApi
>("Province/getAuthList", async (scope, api) => {
  return send(S.getProvinceAuthList(scope), api);
});
